<fui-inline-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        @if (icon) {
            <fui-fixture>
                <ng-content select="fui-icon"></ng-content>
            </fui-fixture>
        }
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)"
                       [(ngModel)]="displayedValue"
                       [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text" inputmode="decimal">
            </fui-input-dom>
        </fui-spanning-fixture>
        @if (notation) {
            <fui-fixture>
                <fui-notation [title]="notation"></fui-notation>
            </fui-fixture>
        }
        @if (validateable) {
            <fui-fixture>
                <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-inline-fascia>
